<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"            
            :actions="actions"
            :refresh.sync="refreshTable"
            ajax-path="postfix/logs"
        />
    </div>
</template>

<script>

    export default {
        data() {
            return {
                refreshTable: false,
                columns: [
                    {
                        title: 'Message', 
                        field: 'Message', 
                        sorter: 'string',
                        minWidth: 500,
                    },
                    {
                        title: 'Date',
                        field: 'created_at_for_human',
                        sorter: 'string',
                        width: 200,
                    },
                    {
                        title: 'Facility',
                        field: 'facility_for_human',
                        sorter: 'number',
                        width: 120,
                        formatter({_cell}) {
                            return `<span style="color: ${_cell.value.color};background-color: ${_cell.value.bg_color};padding: 2px 10px;border-radius: 3px;font-size: .75rem;">${_cell.value.label}</span>`;
                        }
                    },
                    {
                        title: 'Severity',
                        field: 'severity_for_human',
                        sorter: 'number',
                        width: 115,
                        formatter({_cell}) {
                            return `<span style="color: ${_cell.value.color};background-color: ${_cell.value.bg_color};padding: 2px 10px;border-radius: 3px;font-size: .75rem;">${_cell.value.label}</span>`;
                        }
                    },
                    {
                        title: 'Tag', 
                        field: 'SysLogTag', 
                        sorter: 'string',
                        width: 200,
                    },                    
                ],
                actions: [],
            }
        }
    }
</script>